import React, { Component } from 'react';
import { Tooltip } from 'reactstrap';
import autobind from 'react-autobind'
import featuredImg from './featured-sm.png'
export default class ProductBoxListItem extends Component {

    constructor(props) {
        super(props)
        autobind(this)
        this.state = {
            editTooltipOpen: false,
            deleteTooltipOpen: false,
            allowDownloadTooltipOpen: false,
            allowFavouriteTooltipOpen: false,
            allowShareTooltipOpen: false,
            moreTagsTooltip: false,
            viewInARTooltipOpen: false
        }
    }

    toggleEditTooltipOpen() {
        this.setState({
            editTooltipOpen: !this.state.editTooltipOpen
        })
    }

    toggleViewInARTooltipOpen() {
        this.setState({
            viewInARTooltipOpen: !this.state.viewInARTooltipOpen
        })
    }
    toggleDeleteTooltipOpen() {
        this.setState({
            deleteTooltipOpen: !this.state.deleteTooltipOpen
        })
    }



    render() {

        const { productId } = this.props

        return (

            <div className="col-3" key={this.props.index} >
                <div className="p-3" >
                    <div className="product-upload__image-container" style={{width: "auto"}}>
                        <div className="product-upload__image-edit product-action-left">
                            <span className="ar-icon s7-diamond" onClick={() => { this.props.viewInARProduct(this.props.productId) }} id={`viewInAR${productId}`}></span>
                            <Tooltip placement="top" isOpen={this.state.viewInARTooltipOpen} target={`viewInAR${productId}`} toggle={this.toggleViewInARTooltipOpen}>
                                View in AR
                            </Tooltip>

                        </div>
                        <div className="product-upload__image-edit product-action-center">

                            <span className="ar-icon s7-edit" onClick={() => { this.props.editProduct(this.props.productId) }} id={`editTooltip${productId}`}></span>
                            <Tooltip placement="top" isOpen={this.state.editTooltipOpen} target={`editTooltip${productId}`} toggle={this.toggleEditTooltipOpen}>
                                Edit product
                            </Tooltip>

                        </div>
                        <div className="product-upload__image-edit product-action-right">
                            <span className="ar-icon s7-trash" onClick={() => { this.props.deleteProduct(this.props.productId) }} id={`deleteTooltip${productId}`}></span>
                            <Tooltip placement="top" isOpen={this.state.deleteTooltipOpen} target={`deleteTooltip${productId}`} toggle={this.toggleDeleteTooltipOpen}>
                                Delete product
                            </Tooltip>
                        </div>
                        <img src={this.props.imagePath} draggable="false"
                             className="product-gallery-image not-draggable" alt="Product" style={{maxHeight : "auto"}}/>
                    </div>
                    <div className="p-2 bg-light">{this.props.title}</div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Product/ProductBoxListItem.js